import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { storage } from '@/configs/storage';
import { REGISTRATION_STORE_KEY } from '@/features/authorization/constants/store';
import type {
  PersonCreate,
  PersonProfile,
  PersonGeoArea
} from '@/features/authorization/types/person';
import type { AuthStep } from '@/features/authorization/types/step';
import {
  getNextStep,
  getPreviousStep
} from '@/features/authorization/utils/registration';

export type RegistrationStore = {
  step?: AuthStep;
  updateRegistrationStep: (direction?: 'next' | 'previous') => void;
  personCreate?: PersonCreate;
  updatePersonProfile: (profile: PersonProfile) => void;
  updatePersonGeoArea: (geoArea: PersonGeoArea) => void;
  reset: () => void;
};

export const useRegistrationStore = create<RegistrationStore>()(
  persist(
    (set, get) => ({
      step: undefined,
      updateRegistrationStep: (direction: 'next' | 'previous' = 'next') => {
        const currentStep = get().step;
        const next = getNextStep(currentStep);
        const previous = getPreviousStep(currentStep);
        set({ step: direction === 'next' ? next : previous });
      },
      personCreate: undefined,
      updatePersonProfile: (profile: PersonProfile) => {
        const currentPersonCreate = get().personCreate;
        set({
          personCreate: {
            ...currentPersonCreate,
            ...profile
          } as PersonCreate
        });
      },
      updatePersonGeoArea: (geoArea: PersonGeoArea) => {
        const currentPersonCreate = get().personCreate;
        set({
          personCreate: {
            ...currentPersonCreate,
            ...geoArea
          }
        });
      },
      reset: () => {
        set({ personCreate: undefined });
        set({ step: undefined });
      }
    }),
    {
      name: REGISTRATION_STORE_KEY,
      storage: createJSONStorage(() => storage)
    }
  )
);
